if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.announcement = this.querySelector('.announcement');
      this.backgrounds = this.querySelectorAll('.announcement-bg');

      const observer = new MutationObserver(this.mutationCallback.bind(this));
      const config = { attributes: true, attributeFilter: ['class'] };
      this.querySelectorAll('.slideshow__slide').forEach((el) => {
        observer.observe(el, config);
      });
    }

    mutationCallback(mutationList) {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          if (mutation.target.classList.contains('is-active')) {
            this.setActiveSlide(mutation.target);
          }
        }
      }
    }

    setActiveSlide(slide) {
      this.announcement.style.setProperty('--announcement-text-color', slide.dataset.textColor);
      this.backgrounds.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === slide.dataset.index);
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}

if (!customElements.get('sjeng-delivery-message')) {
  const deliveryTime = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam',
    weekday: 'short',
    hour: '2-digit',
    hourCycle: 'h23'
  });

  class SjengDeliveryMessage extends HTMLElement {
    constructor() {
      super();
      this.updateMessage = this.updateMessage.bind(this);
    }

    connectedCallback() {
      this.updateMessage();
      document.addEventListener('visibilitychange', this.updateMessage);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.updateMessage);
    }

    updateMessage() {
      const { weekday, hour } = Object.fromEntries(
        deliveryTime.formatToParts(new Date()).map(({ type, value }) => [type, value])
      );
      // Buiten ma-vr 00:00–21:00 tonen we het alternatieve bericht. Geen feestdagenregeling.
      const outsideHours = weekday === 'Sat' || weekday === 'Sun' || Number(hour) >= 21;
      const before = this.querySelector('[data-delivery-before]');
      const after = this.querySelector('[data-delivery-after]');

      if (before && after) {
        before.hidden = outsideHours;
        after.hidden = !outsideHours;
      } else {
        const text = outsideHours
          ? (this.dataset.afterCutoff || 'Gratis verzending voor members')
          : (this.dataset.beforeCutoff || 'Voor 21:00 besteld, morgen in huis');
        if (this.textContent !== text) this.textContent = text;
      }

      clearTimeout(this.timer);
      this.timer = setTimeout(this.updateMessage, 60000 - (Date.now() % 60000));
    }
  }

  customElements.define('sjeng-delivery-message', SjengDeliveryMessage);
}
